(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function getDrawer() { return document.querySelector('#mini-cart'); }

  function showMsg(text) {
    var msg = document.querySelector('[data-vsl-coupon-msg]');
    if (msg) { msg.textContent = text; msg.hidden = false; }
  }

  function setLoading(btn, on) {
    if (!btn) return;
    btn.disabled = on;
    btn.textContent = on ? 'APLICANDO…' : 'APLICAR';
  }

  function discountApplied(cart, code) {
    var c = (code || '').trim().toLowerCase();
    function has(list) {
      return (list || []).some(function (a) {
        var t = a.title || (a.discount_application && a.discount_application.title) || '';
        return t.toLowerCase() === c;
      });
    }
    if (has(cart.cart_level_discount_applications)) return true;
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (has(items[i].line_level_discount_allocations)) return true;
    }
    return false;
  }

  function swapDrawer(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('#mini-cart');
    var current = getDrawer();
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  function updateCart(discountValue) {
    var current = getDrawer();
    var sectionId = (current && current.getAttribute('section')) || 'mini-cart';
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        discount: discountValue,
        sections: sectionId,
        sections_url: window.location.pathname
      })
    }).then(function (res) {
      return res.json().then(function (cart) {
        return { ok: res.ok, cart: cart, sectionId: sectionId };
      });
    });
  }

  function applyCoupon(code, btn) {
    code = (code || '').trim();
    if (!code) { showMsg('Digite um cupom.'); return; }
    setLoading(btn, true);
    updateCart(code).then(function (r) {
      if (r.ok && discountApplied(r.cart, code)) {
        swapDrawer(r.cart.sections && r.cart.sections[r.sectionId]);
      } else {
        setLoading(btn, false);
        showMsg('Cupom inválido ou expirado.');
      }
    }).catch(function () {
      setLoading(btn, false);
      showMsg('Não foi possível aplicar agora. Tente novamente.');
    });
  }

  function removeCoupon() {
    updateCart('').then(function (r) {
      swapDrawer(r.cart.sections && r.cart.sections[r.sectionId]);
    }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var applyBtn = e.target.closest('[data-vsl-coupon-apply]');
    if (applyBtn) {
      var zone = applyBtn.closest('[data-vsl-coupon]');
      var input = zone && zone.querySelector('[data-vsl-coupon-input]');
      applyCoupon(input ? input.value : '', applyBtn);
      return;
    }
    if (e.target.closest('[data-vsl-remove]')) removeCoupon();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-vsl-coupon-input]');
    if (!input) return;
    e.preventDefault();
    var zone = input.closest('[data-vsl-coupon]');
    applyCoupon(input.value, zone && zone.querySelector('[data-vsl-coupon-apply]'));
  });
})();